import { Injectable } from '@angular/core';
import { HttpService } from '@app/core/http/http.service';
import { Observable } from 'rxjs';

@Injectable()
export class XmlService
{
  private sApiTransformXmlToHtml = '/api/xml/transformXmlToHtml';

  constructor(private httpService: HttpService) { }

  public transformXmlToHtml() : Observable<string>
  {
    return this.httpService.get<string>(this.sApiTransformXmlToHtml);
  }

}
